import SEO from "@/components/SEO";

const MentionsLegalesPage = () => {
  return (
    <>
      <SEO
        title="Mentions Légales | Lenvia"
        description="Mentions légales du site Lenvia, filiale du groupe Proxiad."
      />
      
      <div className="pt-28 pb-20">
        <div className="lenvia-container max-w-4xl">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-10">
            Mentions <span className="gradient-text">légales</span>
          </h1>

          <div className="space-y-8 text-slate-400">
            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">Éditeur du site</h2>
              <div className="space-y-2">
                <p>Le site Lenvia est édité par :</p>
                <p className="font-medium text-white">LENVIA</p>
                <p>Filiale du groupe Proxiad</p>
                <p>Société de services en ingénierie informatique (ESN)</p>
                <div className="pt-2">
                  <p><strong>Siège social :</strong> Paris, France</p>
                  <p><strong>Email :</strong> <a href="mailto:contact@lenvia.eu" className="text-lenvia-blue hover:text-white transition-colors">contact@lenvia.eu</a></p>
                </div>
              </div>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">Directeur de la publication</h2>
              <p>Lenvia</p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">Hébergement</h2>
              <p>Le site est hébergé par un prestataire technique conforme aux standards de sécurité du marché.</p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">Propriété intellectuelle</h2>
              <p className="mb-4">
                L'ensemble du contenu présent sur ce site (textes, images, graphismes, logo, etc.) est la propriété exclusive de Lenvia, sauf mention contraire.
              </p>
              <p>
                Toute reproduction, distribution ou utilisation sans autorisation préalable est strictement interdite.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">Responsabilité</h2>
              <p className="mb-4">
                Lenvia s'efforce d'assurer l'exactitude des informations diffusées sur le site.
              </p>
              <p>
                Toutefois, elle ne saurait être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">Données personnelles</h2>
              <p className="mb-4">
                Les informations collectées via les formulaires sont destinées exclusivement à Lenvia dans le cadre de la gestion des demandes.
              </p>
              <p>
                Elles ne sont en aucun cas revendues à des tiers.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">Droit applicable</h2>
              <p>Le site est soumis au droit français.</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default MentionsLegalesPage;
